import { memo, useEffect, useState } from 'react';

import { Form, Input } from 'antd';

import equal from 'fast-deep-equal';

import messages from '../../../../constants/messages';

import AppModal from '../../../../components/AppModal';

const initialValues = {
  appeui: null,
  carrier_type: null,
  gweui: null,
  identifier: null,
  name: null,
  version: null
};

function GatewayNewModal({ isOpen, submittable, onSubmit, onCancel, formRef, onChange, setCreateFormSubmittable }) {
  const [form] = Form.useForm();
  if (formRef) formRef.current = form;
  const values = Form.useWatch([], form);

  const [initialFormValues, setInitialFormValues] = useState({});
  const [gatewayData, setGatewayData] = useState(initialValues);

  useEffect(() => {
    const initial = form.getFieldsValue(true);
    setInitialFormValues(initial);
  }, []);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setCreateFormSubmittable?.(true))
      .catch(() => setCreateFormSubmittable?.(false));
  }, [values]);

  const onGatewayChange = (value, field) => {
    setGatewayData({
      ...gatewayData,
      [field]: value
    });
  };

  function handleChange() {
    const current = form.getFieldsValue();
    const isSame = equal(current, initialFormValues);

    onChange?.(!isSame);
  }

  return (
    <AppModal
      confirmButtonText="Add gateway"
      title="Add Kraal Gateway"
      confirmButtonDisabled={!submittable}
      isOpen={isOpen}
      handleCancel={onCancel}
      handleConfirm={() => onSubmit(gatewayData)}>
      <Form
        autoComplete="off"
        className="py-4"
        layout="vertical"
        variant="outlined"
        form={form}
        initialValues={initialValues}
        requiredMark={true}
        onValuesChange={handleChange}>
        <Form.Item
          label="Appeui"
          name="appeui"
          rules={[{ required: true, message: messages.FIELD_REQUIRED('Appeui') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'appeui')} />
        </Form.Item>
        <Form.Item label="Gweui" name="gweui" rules={[{ required: true, message: messages.FIELD_REQUIRED('Gweui') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'gweui')} />
        </Form.Item>
        <Form.Item
          label="Identifier"
          name="identifier"
          rules={[{ required: true, message: messages.FIELD_REQUIRED('Identifier') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'identifier')} />
        </Form.Item>
        <Form.Item label="Name" name="name" rules={[{ required: true, message: messages.FIELD_REQUIRED('Name') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'name')} />
        </Form.Item>
        <Form.Item
          label="Version"
          name="version"
          rules={[{ required: true, message: messages.FIELD_REQUIRED('Version') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'version')} />
        </Form.Item>
        <Form.Item
          label="Carrier Type"
          name="carrier_type"
          rules={[{ required: true, message: messages.FIELD_REQUIRED('Carrier Type') }]}>
          <Input onChange={e => onGatewayChange(e.target.value, 'carrier_type')} />
        </Form.Item>
      </Form>
    </AppModal>
  );
}

export default memo(GatewayNewModal);
